import BarChartJS from 'general/components/ChartJS/BarChartJS';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

SaleReconciliationView.propTypes = {
  reconciliationDetail: PropTypes.object,
};

function SaleReconciliationView(props) {
  // MARK: ---- PROPERTIES ----
  const { reconciliationDetail } = props;
  console.log({ reconciliationDetail });
  const saleByDateChartEl = useMemo(() => {
    const labels = _.map(reconciliationDetail?.metadata?.sale_results?.saleByDate, (item) => {
      return item.date;
    });
    const values = _.map(reconciliationDetail?.metadata?.sale_results?.saleByDate, (item) => {
      return item.amount / 1000000;
    });
    return (
      <BarChartJS
        dataType="revenue"
        horizontal={false}
        showTitle={false}
        labels={labels}
        datasets={[
          {
            label: 'Doanh số',
            data: values,
            borderColor: '#8676FF4D',
            backgroundColor: '#8676FF4D',
            hoverColor: '#8676FF',
            appendUnit: 'triệu',
            stepSize: Utils.getNearestMultipleOfFive(Math.max(...values)) / 5,
            max: Utils.getNearestMultipleOfFive(Math.max(...values)),
          },
        ]}
      />
    );
  }, [reconciliationDetail]);
  const packageByDateChartEl = useMemo(() => {
    const labels = _.map(reconciliationDetail?.metadata?.package_results?.saleByDate, (item) => {
      return item.date;
    });
    const values = _.map(reconciliationDetail?.metadata?.package_results?.saleByDate, (item) => {
      return item.amount / 1000000;
    });
    return (
      <BarChartJS
        dataType="revenue"
        horizontal={false}
        showTitle={false}
        labels={labels}
        datasets={[
          {
            label: 'Doanh số',
            data: values,
            borderColor: '#8676FF4D',
            backgroundColor: '#8676FF4D',
            hoverColor: '#8676FF',
            appendUnit: 'triệu',
            stepSize: Utils.getNearestMultipleOfFive(Math.max(...values)) / 5,
            max: Utils.getNearestMultipleOfFive(Math.max(...values)),
          },
        ]}
      />
    );
  }, [reconciliationDetail]);

  return (
    <div className="pt-4" style={{ backgroundColor: AppColors.gray[100] }}>
      <div className="row m-0 p-0 px-3">
        {/* thong tin doanh so ban tru sac */}
        <div className="col-lg-6 p-2 mb-4">
          {UIHelper.buildCard(
            <div>
              {/* header */}
              <div>{UIHelper.buildCardHeader('Doanh số nhượng quyền')}</div>
              {/* chart */}
              <div
                className="h-300px p-4"
                style={{
                  borderBottom: `1px dashed ${AppColors.gray[300]}`,
                }}
              >
                {saleByDateChartEl}
              </div>
              {/* thong tin */}
              <div className="row m-0 p-0">
                <div className="col-6">
                  <div className="d-flex flex-column gap-4 py-4">
                    {UIHelper.buildNameAndValue(
                      'Số đơn hàng bán được',
                      Utils.formatNumber(reconciliationDetail?.metadata?.sale_results?.totalSale)
                    )}
                    {UIHelper.buildNameAndValue(
                      'Tỷ lệ hoa hồng dự kiến',
                      `${
                        reconciliationDetail?.metadata?.sale_results?.estimatedSaleCommissionRate *
                        100
                      }%`
                    )}
                  </div>
                </div>
                <div className="col-6">
                  <div className="d-flex flex-column gap-4 py-4">
                    {UIHelper.buildNameAndValue(
                      'Tổng doanh số bán được',
                      `${Utils.formatNumber(
                        reconciliationDetail?.metadata?.sale_results?.amountSale
                      )} VNĐ`
                    )}
                    {UIHelper.buildNameAndValue(
                      'Số tiền hoa hồng dự kiến',
                      `${Utils.formatNumber(
                        reconciliationDetail?.metadata?.sale_results?.estimatedSaleCommissionAmount
                      )} VNĐ`
                    )}
                  </div>
                </div>
              </div>
            </div>,
            false
          )}
        </div>

        {/* thong tin doanh so ban goi dau tu HTKD */}
        <div className="col-lg-6 p-2 mb-4">
          {UIHelper.buildCard(
            <div>
              {/* header */}
              <div>{UIHelper.buildCardHeader('Doanh số bán gói đầu tư HTKD')}</div>
              {/* chart */}
              <div
                className="h-300px p-4"
                style={{
                  borderBottom: `1px dashed ${AppColors.gray[300]}`,
                }}
              >
                {packageByDateChartEl}
              </div>
              {/* thong tin */}
              <div className="row m-0 p-0">
                <div className="col-6">
                  <div className="d-flex flex-column gap-4 py-4">
                    {UIHelper.buildNameAndValue(
                      'Số đơn hàng bán được',
                      Utils.formatNumber(reconciliationDetail?.metadata?.package_results?.totalSale)
                    )}
                    {UIHelper.buildNameAndValue(
                      'Tỷ lệ hoa hồng dự kiến',
                      `${
                        reconciliationDetail?.metadata?.package_results
                          ?.estimatedPackageCommissionRate * 100
                      }%`
                    )}
                  </div>
                </div>
                <div className="col-6">
                  <div className="d-flex flex-column gap-4 py-4">
                    {UIHelper.buildNameAndValue(
                      'Tổng doanh số bán được',
                      `${Utils.formatNumber(
                        reconciliationDetail?.metadata?.package_results?.amountSale
                      )} VNĐ`
                    )}
                    {UIHelper.buildNameAndValue(
                      'Số tiền hoa hồng dự kiến',
                      `${Utils.formatNumber(
                        reconciliationDetail?.metadata?.package_results
                          ?.estimatedPackageCommissionAmount
                      )} VNĐ`
                    )}
                  </div>
                </div>
              </div>
            </div>,
            false
          )}
        </div>
      </div>
    </div>
  );
}

export default SaleReconciliationView;
